<script>
import storageService from "@/services/storage.service";
import Layout from "../../layouts/auth";
import appConfig from "@/app.config";
import axios from "axios";
import { required, email, helpers, maxLength } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

import customTokenCredential from "../../../CustomTokenProvider";
import { BlobServiceClient } from "@azure/storage-blob";
import { PublicClientApplication } from "@azure/msal-browser";
import { mapMutations } from "vuex";
const storageAccountName = "cmatskasbackup";

// Forgot Password component
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  mounted() {
    const accounts = this.$msalInstance.getAllAccounts();
    if (window.location.href.includes("logout")) {
      if (accounts.length != 0) {
        this.SignOut();
      } else {
        this.account = undefined;
        storageService.clear();
        storageService.removeSessionItem("msal.interaction.status");
        this.make_it_load = false;
      }
    } else {
      if (accounts.length == 0) {
        this.make_it_load = false;
        return;
      }
      this.account = accounts[0];
      this.make_it_load = false;
      this.SignIn();
    }
  },
  validations: {
    email: {
      required: helpers.withMessage("Email is required", required),
      email: helpers.withMessage("Please enter valid email", email),
    },
    maxlength: {
      required: helpers.withMessage("Maxlength is required", required),
      maxLength: maxLength(4),
    },
  },
  page: {
    title: "Forgot Password",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  async created() {
    this.$msalInstance = new PublicClientApplication(
      this.$store.state.msalConfig,
    );
    this.$emitter.on(
      "logout",
      async function () {
        await this.SignOut();
      }.bind(this),
    );
  },
  data() {
    return {
      notchoosen: true,
      upass: false,
      email: "",
      showForm1: false, // Initially show the first form
      showForm2: false,
      showForm3: false,
      copiedEmail: "",
      isLoading: false,
      isSubmitting: false,
      isDisabled: false,
      otp: "",
      toload: true,
      account: undefined,
      containers: [],
      myat: "",
      make_it_load: true,
      showErrorMessage: false,
      myerrors: "",
      signin: "https://microsoft.com",
    };
  },
  methods: {
    async SignIn() {
      if (this.$msalInstance.getAllAccounts()) {
        storageService.removeSessionItem("msal.interaction.status");
      }
      await this.$msalInstance.initialize();
      await this.$msalInstance
        .loginPopup({})
        .then(() => {
          const myAccounts = this.$msalInstance.getAllAccounts();
          this.account = myAccounts[0];

          this.getAzureStorageData();
          this.getAccessToken();
          this.tryToLogin(true, this.account.username);
        })
        .catch(() => {
          storageService.removeSessionItem("msal.interaction.status");
        });
    },
    async SignOut() {
      await this.$msalInstance.initialize();
      await this.$msalInstance
        .logout({})
        .then(() => {
          this.account = undefined;
          storageService.clear();
          storageService.removeSessionItem("msal.interaction.status");
        })
        .catch(() => {
          storageService.removeSessionItem("msal.interaction.status");
        });
    },
    async tryToReset(overide = false) {
      if (this.isLoading) return;
      if (!this.copiedEmail) {
        this.myerrors = "Please enter your email.";
        this.showErrorMessage = true;
        this.isLoading = false;
        setTimeout(() => {
          this.showErrorMessage = false;
        }, 1500);
        return;
      }
      overide = overide == true ? true : false;
      this.isLoading = true;
      this.make_it_load = true;
      this.isDisabled = true;
      await axios
        .post("/accounts/otp_send/", { email: this.copiedEmail, page: "staff" })
        .then((response) => {
          // Handle the response
          if (response.data.loginby == "msal" && !overide) {
            this.SignIn();
            this.make_it_load = false;
          } else {
            this.myerrors = "Account not found!";
            this.showErrorMessage = true;
            this.isLoading = false;
            this.make_it_load = false;
            setTimeout(() => {
              this.showErrorMessage = false;
            }, 1500);
          }
        })
        .catch(() => {
          // Handle any errors
          this.isLoading = false;
          this.make_it_load = false;
          this.isDisabled = false;
          this.myerrors = "Network or server error sending OTP. Please try again.";
          this.showErrorMessage = true;
          setTimeout(() => {
            this.showErrorMessage = false;
          }, 2500);
        });
    },
    async tryToLogin(remember = false, sr = null) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      sr = String(sr).includes("@") ? sr : this.copiedEmail;
      const at = this.$store.state.accessToken
        ? this.$store.state.accessToken
        : null;
      axios
        .post("/accounts/login/", {
          email: sr,
          otp: this.otp,
          remember: remember,
          at: at,
        })
        .then((response) => {
          this.isSubmitting = false;
          // Handle the response
          if (response.data.status == "SUCCESS") {
            const accessToken = response.data.access;
            const role = response.data.role;

            storageService.setItem("accessToken", accessToken);
            storageService.setItem("userEmail", sr);

            if (role === "staff" || role === "verification officer") {
              storageService.setItem("userType", role);
              this.$router.push({ name: "Dashboard" });
            } else {
              storageService.setItem("userType", "admin");
              this.$router.push({ name: "admin dashaboard" });
            }

          } else {
            this.myerrors = response.data.error || response.data.message || "Invalid credentials";
            this.showErrorMessage = true;
            setTimeout(() => {
              this.showErrorMessage = false;
            }, 2500);
            storageService.removeSessionItem("msal.interaction.status");
            storageService.clear();
            if (this.account) {
              this.account = undefined;
              this.SignOut();
            }
          }
        })
        .catch((error) => {
          this.isSubmitting = false;
          const res = error.response;
          if (res && res.status === 401) {
            storageService.clear();
          }
          // 401 = wrong credentials, 403 = deactivated account: show the server's message
          const deactivated = !!(res && res.data && res.data.code === "ACCOUNT_DEACTIVATED");
          this.myerrors =
            (res &&
              (res.status === 401 || res.status === 403) &&
              res.data &&
              res.data.error) ||
            "Network or server error during login. Please try again.";
          this.showErrorMessage = true;
          setTimeout(() => {
            this.showErrorMessage = false;
          }, 4000);
          // a Microsoft session must not auto-retry (and loop) for a deactivated account
          if (deactivated) {
            storageService.removeSessionItem("msal.interaction.status");
            storageService.clear();
            if (this.account) {
              this.account = undefined;
              this.SignOut();
            }
          }
        });
    },
    ...mapMutations(["setAccessToken"]),
    async getAzureStorageData() {
      if (this.$store.state.accessToken == "") {
        await this.getAccessToken();
      }
      let tokenCredential = new customTokenCredential(
        this.$store.state.accessToken,
      );
      const blobClient = new BlobServiceClient(
        `https://${storageAccountName}.blob.core.windows.net`,
        tokenCredential,
      );

      const iter = blobClient.listContainers();
      let containerItem = await iter.next();
      while (!containerItem.done) {
        this.containers.push({
          id: containerItem.value.properties.etag,
          name: containerItem.value.name,
        });
        containerItem = await iter.next();
      }
    },
    async getAccessToken() {
      let request = {
        scopes: ["https://storage.azure.com/user_impersonation"],
      };
      const msalInstance = new PublicClientApplication(
        this.$store.state.msalConfig,
      );
      try {
        let tokenResponse = await msalInstance.acquireTokenSilent(request);
        this.$store.commit("setAccessToken", tokenResponse.accessToken);
      } catch (error) {
        let tokenResponse = await msalInstance.acquireTokenPopup(request);
        this.$store.commit("setAccessToken", tokenResponse.accessToken);
      }
    },
    async chasemsal() {
      this.showForm2 = true;
      this.upass = false;
      this.notchoosen = false;
    },
    async chasemail() {
      this.showForm2 = true;
      this.upass = true;
      this.notchoosen = false;
    },
  },
};
</script>

<template>
  <div class="loader-main" id="make_it_load" v-if="make_it_load">
    <div class="loader"></div>
  </div>
  <Layout>
    <div class="eauth-shell">
      <div class="eauth-card">
        <img
          class="eauth-logo"
          src="@/assets/images/ECU/ECU-logo.jpg"
          alt="Eastern Credit Union"
        />
        <div class="eauth-accent"></div>

        <div v-if="showErrorMessage" class="eauth-alert eauth-alert--error" role="alert">
          <i class="mdi mdi-alert-circle-outline"></i>
          <span>{{ myerrors }}</span>
        </div>

        <!-- Choose how to sign in -->
        <div v-if="notchoosen">
          <h1 class="eauth-title">Get Started</h1>
          <p class="eauth-sub">Choose a sign in option to access your account.</p>

          <button type="button" class="eauth-option eauth-option--accent" @click="chasemsal()">
            <span class="eauth-option__icon">
              <img src="@/assets/images/login_msal.png" alt="Microsoft" />
            </span>
            <span class="eauth-option__text">
              <h4>Sign in with Microsoft</h4>
              <p>For Microsoft-365 Account</p>
            </span>
            <span class="eauth-option__arrow"><i class="mdi mdi-arrow-right"></i></span>
          </button>

          <div class="eauth-or"><span>OR</span></div>

          <button type="button" class="eauth-option" @click="chasemail()">
            <span class="eauth-option__icon">
              <i class="mdi mdi-email-outline"></i>
            </span>
            <span class="eauth-option__text">
              <h4>Sign up with email</h4>
            </span>
            <span class="eauth-option__arrow"><i class="mdi mdi-arrow-right"></i></span>
          </button>
        </div>

        <!-- Email (+ password) form -->
        <form v-if="showForm2" @submit.prevent="tryToLogin()">
          <h1 class="eauth-title">Login to Your Account</h1>
          <p class="eauth-sub">
            {{ upass ? "Enter your email and password to access your account." : "Enter your email to access your account." }}
          </p>

          <div class="eauth-group">
            <label class="eauth-label" for="useremail">Email</label>
            <div class="eauth-field">
              <i class="mdi mdi-email-outline eauth-field__icon"></i>
              <input
                type="email"
                v-model="copiedEmail"
                class="eauth-input"
                id="useremail"
                placeholder="Enter email"
                autocomplete="email"
                required
              />
            </div>
          </div>

          <div class="eauth-group" v-if="upass">
            <label class="eauth-label" for="otpId">Password</label>
            <div class="eauth-field">
              <i class="mdi mdi-lock-outline eauth-field__icon"></i>
              <input
                type="password"
                v-model="otp"
                class="eauth-input"
                id="otpId"
                placeholder="Enter your password"
                autocomplete="current-password"
              />
            </div>
            <div class="eauth-row-end">
              <router-link to="/forgot-password" class="eauth-link">
                Forgot password?
              </router-link>
            </div>
          </div>

          <div class="eauth-actions">
            <button
              class="eauth-btn eauth-btn--ghost"
              type="button"
              @click="notchoosen = true; showForm2 = false"
            >
              <i class="mdi mdi-arrow-left"></i> Back
            </button>
            <button
              v-if="upass"
              class="eauth-btn eauth-btn--primary"
              type="submit"
              :disabled="isSubmitting"
            >
              <span v-if="isSubmitting">Logging in...</span>
              <template v-else>Login <i class="mdi mdi-arrow-right"></i></template>
            </button>
            <button
              v-else
              class="eauth-btn eauth-btn--primary"
              type="button"
              :disabled="isLoading"
              @click="tryToReset(false)"
            >
              Login <i class="mdi mdi-arrow-right"></i>
            </button>
          </div>
        </form>
      </div>

      <div class="eauth-footer">
        <p>
          © {{ new Date().getFullYear() }} ECU. Crafted with by
          <a target="_blank" rel="noopener" href="https://midriffinfosolution.org/">MISPL</a>
        </p>
      </div>
    </div>
  </Layout>
</template>